(() => {
    const url = '/app/platform-wc/eh-marquee/dist/dataprovider/marquee.js'
    function loadScript(url, callback, callbackError) {
        var script= document.createElement('script');
        script.type= 'text/javascript';
        script.src = url;
        script.async = true;

        try {
            if (script.readyState) {  //IE
                script.onreadystatechange = function () {
                    if (script.readyState === "loaded" || script.readyState === "complete") {
                        script.onreadystatechange = null;
                        callback();
                    }
                };
            } else {
                //其餘瀏覽器支援onload
                script.onload = function () {
                    callback();
                };
            }
            document.getElementsByTagName("head")[0].appendChild(script);
        } catch (e) {
            if (null !== callbackError) callbackError(e);
        }
    }

    function getMarquees() {
        return window.eHanlin.dataprovider.marquee.data
    }

    async function initData(viewData) {
        const data = await getMarquees();
        data.forEach(el => {
            viewData.push({
                status: el.status && el.status.trim() !== "" ? el.status : "simple",
                content: el.text,
                btn_text: el.btnText && el.btnText.trim() !== "" ? el.btnText : "",
                btn_href: el.btnHref && el.btnHref.trim() !== "" ? el.btnHref : ""
            });
        });
    }

    function composeMarquee(data) {
        const node = document.createElement('div');
        node.classList.add('marquee');
        let iconName = "";
        let btnTextHide = data.btn_text.trim() === "" ? "hide" : "";
        let btnHrefHide = data.btn_href.trim() === "" ? "hide" : "";
        switch (data.status) {
            case 'simple': {
                iconName = "point";
                break;
            }
            case 'secondary': {
                iconName = "tag";
                break;
            }
            case 'primary': {
                iconName = "alert";
                break;
            }
        }
        node.innerHTML = `
        <div class="container-marquee ${data.status}-bg">
            <div class="content content-${data.status}">
                <div class="wrap-content">
                    <div class="icon"><img src="${window.eHanlin.platform_env.cdn}/web/eh-marquee/${iconName}.svg" alt="icon"></div>
                    <div id="content">${data.content}</div>
                </div>
            </div>
            <a class="btn ${data.status}-btn ${btnHrefHide}" href="${data.btn_href}">
                <div class="btn-txt ${btnTextHide}">${data.btn_text}</div>
            </a>
        </div>
        `
        return node
    }

    async function defineCustomElement() {
        const template = `
            <style>
                .btn,.btn-txt{
                    text-decoration:none
                }
                .content,.marquee-run{
                    white-space:nowrap!important
                }
                *{
                    -webkit-box-sizing:border-box;
                    box-sizing:border-box
                }
                .hide{
                    display:none
                }
                .col-content,.container-marquee{
                    display:-webkit-box;
                    display:-ms-flexbox
                    display:flex
                }
                .marquees{
                    z-index:90000;
                    -webkit-transition:.3s;
                    transition:.3s;
                    position:fixed;
                    top:52px;
                    left:0;
                    font-family:'Noto Sans TC',sans-serif;
                    font-weight:400;
                    height:36px;
                    width:100%;
                    overflow:hidden;
                    -webkit-box-shadow:0 0px 3px rgba(0,0,0,.15);
                    box-shadow:0 0px 3px rgba(0,0,0,.15);
                    -moz-user-select:none;
                    -webkit-user-select:none;
                    -ms-user-select:none;
                    user-select:none;
                }
                .close,.marquee{
                    position:absolute
                }
                .marquee{
                    width:100%;
                    bottom:0;
                    -webkit-transform:translateY(100%);
                    transform:translateY(100%)
                }
                .container-marquee{
                    padding:7px;
                    display:flex;
                    -webkit-box-align:center;
                    -ms-flex-align:center;
                    align-items:center;
                    -webkit-box-pack:center;
                    -ms-flex-pack:center;
                    justify-content:center;
                    height:36px
                }
                .col-content{
                    display:flex;
                    -webkit-box-pack:center;
                    -ms-flex-pack:center;
                    justify-content:center;
                    -webkit-box-align:center;
                    -ms-flex-align:center;
                    align-items:center;
                }.close,.wrap-content{
                    -webkit-box-pack:center
                }
                .content{
                    color:#454545;
                    font-size:12px;
                    font-weight:500;
                    letter-spacing:1px;
                    line-height:18px;
                    width:auto;
                    overflow:hidden
                }
                .wrap-content{
                    cursor:default;
                    display:-webkit-box;
                    display:-ms-flexbox;
                    display:flex;
                    -ms-flex-pack:center;
                    justify-content:center;
                    -ms-flex-line-pack:centers;
                    align-content:center
                }
                @media (max-width:991px){
                    .marquees{
                        top:48px
                    }
                    .content{
                        width:70%
                    }
                    .content-primary{
                        width:100%
                    }
                    .wrap-content{
                        display:none
                    }
                }
                .btn{
                    border-radius:5px;
                    padding:2px 4px;
                    margin-left:12px;
                    width:60px;
                    height:22px
                }
                .btn-txt{
                    color:#fff;
                    font-size:12px;
                    text-align:center
                }
                .primary-bg{
                    background-color:#FFE2E9
                }
                .secondary-bg{
                    background-color:#FFEDC6
                }
                .simple-bg{
                    background-color:#EDF7FF
                }
                .primary-btn{
                    background-color:#DE4747
                }
                .primary-btn:hover{
                    background-color:#D93131
                }
                .secondary-btn{
                    background-color:#FFB677
                }
                .secondary-btn:hover{
                    background-color:#F7A45C
                }
                .simple-btn{
                    background-color:#4B9DE4
                }
                .simple-btn:hover{
                    background-color:#328DDD
                }.close{
                    right:13px;
                    top:13px;
                    display:-webkit-box;
                    display:-ms-flexbox;
                    display:flex;
                    -ms-flex-pack:center;
                    justify-content:center;
                    -webkit-box-align:center;
                    -ms-flex-align:center;
                    align-items:center;
                    cursor:pointer;
                    -webkit-transition:.2s;
                    transition:.2s
                }
                .close:hover{
                    -webkit-transform:scale(.8);
                    transform:scale(.8)
                }
                @media (max-width:991px){
                    .close{
                        display:none
                    }
                }
                .icon{
                    margin-right:5px;
                    display:-webkit-box;
                    display:-ms-flexbox;
                    display:flex;
                    -webkit-box-pack:center;
                    -ms-flex-pack:center;
                    justify-content:center;
                    -ms-flex-line-pack:center;
                    align-content:center
                }
                @media (max-width:991px){
                    .icon{
                        display:none
                    }
                }
                .wipe-in{
                    -webkit-transition:-webkit-transform 1.2s;
                    transition:-webkit-transform 1.2s;
                    transition:transform 1.2s;
                    transition:transform 1.2s,-webkit-transform 1.2s;
                    -webkit-transform:translateY(0);
                    transform:translateY(0)
                }
                .wipe-out{
                    -webkit-transition:-webkit-transform 1.2s;
                    transition:-webkit-transform 1.2s;
                    transition:transform 1.2s;
                    transition:transform 1.2s,-webkit-transform 1.2s;
                    -webkit-transform:translateY(-100%);
                    transform:translateY(-100%)
                }
                .marquee-run{
                    -webkit-animation:marquee 12s linear infinite;
                    animation:marquee 12s linear infinite;
                    display:block
                }
                @media (max-width:767px){
                    .marquee-run{
                        -webkit-animation:marquee 12s linear infinite;
                        animation:marquee 12s linear infinite
                    }
                }
                @media (max-width:539px){
                    .marquee-run{
                        -webkit-animation:marquee-mobile 12s linear infinite;
                        animation:marquee-mobile 12s linear infinite
                    }
                }

                @-webkit-keyframes marquee{
                    0%{
                        margin-left:100%;
                        -webkit-transform:translateX(0);
                        transform:translateX(0)
                    }
                    100%{
                        margin-left:0%;
                        -webkit-transform:translateX(-100%);
                        transform:translateX(-100%)
                    }
                }
                @keyframes marquee{
                    0%{
                        margin-left:100%;
                        -webkit-transform:translateX(0);
                        transform:translateX(0)
                    }
                    100%{
                        margin-left:0%;
                        -webkit-transform:translateX(-100%);
                        transform:translateX(-100%)
                    }
                }

                @-webkit-keyframes marquee-mobile{
                    0%{
                        margin-left:100%;
                        -webkit-transform:translateX(0);
                        transform:translateX(0)
                    }
                    100%{
                        margin-left:0%;
                        -webkit-transform:translateX(-250%);
                        transform:translateX(-250%)
                    }
                }
                @keyframes marquee-mobile{
                    0%{
                        margin-left:100%;
                        -webkit-transform:translateX(0);
                        transform:translateX(0)
                    }
                    100%{
                        margin-left:0%;
                        -webkit-transform:translateX(-250%);
                        transform:translateX(-250%)
                    }
                }

            </style>
            <div class="marquees">
                <slot></slot>
                <div class="close" id="btn-close">
                    <img src="${window.eHanlin.platform_env.cdn}/web/eh-marquee/btn-close.svg" alt="icon">
                </div>
            </div>`;

        const viewData = [];
        await initData(viewData);
        customElements.define('eh-marquee', class extends HTMLElement {
            constructor() {
                super();
                if(viewData.length < 1) return;
                const shadowRoot = this.attachShadow({ mode: 'open' });
                shadowRoot.innerHTML = template;
                viewData.forEach(it => {
                    shadowRoot.querySelector("slot").appendChild(composeMarquee(it));
                });

                // // 跑馬燈
                const marquees = shadowRoot.querySelectorAll('.marquee');
                document.body.style.paddingTop = "36px";
                function wipeIn(element) {
                    element.classList.add('wipe-in');
                }

                function wipeOut(element) {
                    element.classList.add('wipe-out');
                    delay(1000).then(() => reset(element));
                }

                function wordScroll(index) {
                    let wc = shadowRoot.querySelectorAll('.wrap-content');
                    wc[index].classList.add('marquee-run');
                    adjustMarqueeRunWidth(index)
                }

                function wordUnScroll(index) {
                    let wc = shadowRoot.querySelectorAll('.wrap-content');
                    wc[index].classList.remove('marquee-run');
                }

                function adjustMarqueeRunWidth(index){
                    let content = shadowRoot.querySelectorAll('#content');
                    let strLength = content[index].innerHTML.toString().length;
                    let contentWidth;

                    if(strLength<=30 && strLength>20) {
                        contentWidth = "95%" ;
                    }else if((strLength<=40 && strLength>30) || (strLength<=60 && strLength>50)){
                        contentWidth = "90%" ;
                    }else if(strLength<=50 && strLength>40){
                        contentWidth = "85%" ;
                    }else{
                        contentWidth = "100%" ;
                    }
                    let marqueeRun = shadowRoot.querySelector(".marquee-run");
                    marqueeRun.style.width = contentWidth;
                }

                function reset(element) {
                    element.classList = 'marquee';
                }

                function delay(ms) {
                    return new Promise(resolve => setTimeout(resolve, ms));
                }

                function runCarousel(genObj) {
                    if (!genObj.next().done) {
                        setTimeout(runCarousel, 15000, genObj);
                    }
                }

                function* carousel(elements) {
                    for(let pre = -1, i = 0; i< elements.length; i++){
                        if(pre !== -1){
                            wipeOut(elements[pre]);
                            wordUnScroll(pre)
                        }
                        wipeInAndWordScroll(elements[i], i);
                        pre = i;
                        // reset
                        if(i+1 === elements.length) i = -1;
                        yield
                    }
                }

                window.onresize = function () {
                    if (window.innerWidth <= 991) {
                        wordScroll(0);
                    } else {
                        wordUnScroll(0);
                    }
                };

                window.onload = function () {
                    if (window.innerWidth <= 991) {
                        wordScroll(0);
                    }
                };

                if(marquees.length === 1){
                    wipeInAndWordScroll(marquees[0],0)
                }else{
                    runCarousel(carousel(marquees));
                }

                function wipeInAndWordScroll(element, index){
                    wipeIn(element);
                    if (window.innerWidth <= 991) {
                        wordScroll(index);
                    }
                }

                // close btn
                let btn = shadowRoot.getElementById("btn-close");
                btn.addEventListener('click', function () {
                    shadowRoot.querySelector(".marquees").style.display = 'None';
                    document.body.style.paddingTop = "0px";
                }, false)

                // 往下滑隱藏
                let prevPos = window.pageYOffset;

                function addEvent(obj, type, fn) {
                    if (obj.attachEvent) {
                        obj.attachEvent('on' + type, function () {
                            fn.call(obj);
                        })
                    }
                    else {
                        obj.addEventListener(type, fn, false);
                    }
                }

                addEvent(window, 'scroll', function () {
                    if (window.innerWidth <= 991) {
                        document.body.style.paddingTop = "36px";
                        let currentPos = window.pageYOffset;
                        if (prevPos > currentPos || (currentPos < 0 || prevPos < 0)) {
                            shadowRoot.querySelector(".marquees").style.top = "48px";
                            shadowRoot.querySelector(".marquees").style.opacity = "1";
                        }
                        else {
                            shadowRoot.querySelector(".marquees").style.top = "48px";
                            shadowRoot.querySelector(".marquees").style.opacity = "0";
                            document.body.style.paddingTop = "0px";
                        }
                        prevPos = currentPos;

                    }
                });
            }
        });
    }
    loadScript(url, defineCustomElement);
})();




